<template>
<DxForm :form-data="settingsData" label-mode="static" :repaint-changes-only="true" @field-data-changed="handleFieldDataChanged">
	<DxSimpleItem v-if="showSourceSelector" data-field="source" editor-type="dxSelectBox" :editor-options="sourceConfig" />
	<DxSimpleItem v-if="!showSourceSelector && isSubeditor">
		<div style="font-style: italic;">Data is sourced from the relationship {{ settingsData.relationship }}.</div>
	</DxSimpleItem>
	<DxSimpleItem v-if="props.type == 'imageview'">
		<div>Unimplemented: Local ImageView Upload</div>
	</DxSimpleItem>
	<DxSimpleItem v-if="props.type != 'imageview'" data-field="heading" />

	<DxGroupItem>
		<DxSimpleItem v-if="props.type == 'html'" data-field="htmlMode" editor-type="dxSelectBox" :label="{ text: 'Editor Mode' }" :editor-options="htmlModes" />
	</DxGroupItem>	
	<DxGroupItem>
		<CoderPrompter v-if="props.type == 'html'" type="html" :initial="settingsData && settingsData.htmlRawContent ? settingsData.htmlRawContent : ''" @codeChanged="settingsData.htmlRawContent = $event" />
	</DxGroupItem>

	<DxGroupItem v-if="isGridType" css-class="ux-settings-fieldset active always-active">
		<DxSimpleItem data-field="showColumnChooser" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'columnchooser;Allow user to choose columns shown' }" />
		<DxSimpleItem data-field="showSearch" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'search;Show search filter at top' }" css-class="minimize-form-paddings" />
		<DxSimpleItem data-field="showFilterRow" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'rowfield;Show filtering row' }" css-class="minimize-form-paddings" />
		<DxSimpleItem data-field="showHeaderFilter" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'filter;Show heading picker' }" css-class="minimize-form-paddings" />
	</DxGroupItem>

	<DxGroupItem v-if="isGridType" css-class="ux-settings-fieldset active always-active">
		<DxSimpleItem data-field="editingMode" editor-type="dxSelectBox" :editor-options="editingModes" />
		<DxSimpleItem data-field="disallowAdding" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'lock;Stop users from adding new items' }" css-class="minimize-form-paddings" />
		<DxSimpleItem data-field="disallowDeleting" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'lock;Stop users from deleting items' }" css-class="minimize-form-paddings" />
		<DxSimpleItem data-field="hideEditingCommandColumn" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'fixcolumnright;Hide editing command column' }" css-class="minimize-form-paddings" />
		<DxSimpleItem css-class="disable-form-paddings form-hint" :visible="!!settingsData.hideEditingCommandColumn">Users can still access edit/delete commands by right clicking on rows.</DxSimpleItem>
		<DxSimpleItem data-field="disallowImport" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'import;Stop users from importing items' }" css-class="minimize-form-paddings" />
	</DxGroupItem>

	<DxGroupItem v-if="isGridType" css-class="ux-settings-fieldset active always-active">
		<DxSimpleItem data-field="showBorders" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'verticalaligncenter;Show borders around grid' }" css-class="minimize-form-paddings" />
		<DxSimpleItem data-field="showRowLines" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'handlehorizontal;Show lines between rows' }" css-class="minimize-form-paddings" />
		<DxSimpleItem data-field="showColLines" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'handlevertical;Show lines between columns' }" css-class="minimize-form-paddings" />
		<DxSimpleItem data-field="showZebra" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'menu;Show zebra stripes in rows' }" css-class="minimize-form-paddings" />
		<DxSimpleItem data-field="useHoverRowState" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'equal;Highlight row when hovering' }" css-class="minimize-form-paddings" />
	</DxGroupItem>

	<DxGroupItem v-if="isGridType" :css-class="settingsData.useSimpleClick === true ? 'ux-settings-fieldset active' : 'ux-settings-fieldset'">
		<DxSimpleItem data-field="useSimpleClick" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'login;Allow clicking rows' }" />
		<DxSimpleItem :visible="settingsData.useSimpleClick !== true" :css-class="'disable-form-paddings'">
			<div style="display:flex;align-items:center;gap:10px;">
				<img src="../assets/placeholder.jpg" style="width:144px;height:48px;flex-shrink:0" class="placeholder">
				<div style="font-style: italic; color: var(--dx-color-text-muted);">You can allow double-clicking rows to do something simple, like navigating to a page.</div>
			</div>
		</DxSimpleItem>
		<DxSimpleItem :visible="settingsData.useSimpleClick === true" css-class="disable-form-paddings">
			<div style="font-style: italic; color: var(--dx-color-text-muted);">More advanced actions must be configured using the actions editor.</div>
		</DxSimpleItem>
		<DxGroupItem :visible="settingsData.useSimpleClick === true">	
			<DxSimpleItem data-field="simpleClickMode" editor-type="dxSelectBox" :editor-options="simpleClickModes" />
			<!--<DxSimpleItem data-field="simpleClickPage" editor-type="dxSelectBox" :editor-options="simpleClickPages" :visible="settingsData.simpleClickMode == 'page'" css-class="disable-form-paddings" />-->
			<DxSimpleItem data-field="useSimpleClickSingle" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'runner;Use a single click instead of double clicking' }" />
		</DxGroupItem>
	</DxGroupItem>
	
	<DxGroupItem v-if="isGridType" :css-class="settingsData.showMasterDetail === true ? 'ux-settings-fieldset active' : 'ux-settings-fieldset'">
		<DxSimpleItem data-field="showMasterDetail" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'mergecells;Show master detail display' }" />
		<DxSimpleItem :visible="settingsData.showMasterDetail !== true" css-class="disable-form-paddings">
			<div style="display:flex;align-items:center;gap:10px;">
				<img src="../assets/placeholder.jpg" style="width:144px;height:48px;flex-shrink:0" class="placeholder">
				<div style="font-style: italic; color: var(--dx-color-text-muted);">The master detail display allows you to 'expand' a row to show a more detailed view or other data underneath.</div>
			</div>
		</DxSimpleItem>
		<DxGroupItem :visible="settingsData.showMasterDetail === true">
			<DxSimpleItem data-field="masterDetailMode" editor-type="dxSelectBox" :editor-options="masterDetailModes" />
			<DxSimpleItem>
				<div v-if="!Array.isArray(settingsData.masterDetailTabs) || settingsData.masterDetailTabs.length == 0" class="dx-card" style="padding: 15px; margin-bottom: 15px; background-color: #fff4e5; border-left: 4px solid #f6a700;">
					<i class="dx-icon-warning" style="color: #f6a700; font-size: 20px; vertical-align: middle; margin-right: 8px;"></i>
					<span style="color: #5c3c10;">No tabs configured yet - empty master detail display.</span>
				</div>
				<div v-else>
					<div v-for="tab in settingsData.masterDetailTabs" :key="tab.id" class="dx-card" style="padding: 15px; margin-bottom: 10px; border: 1px solid var(--dx-color-border); border-radius: 4px;">
						<div style="display: flex; align-items: center; gap: 5px;">
							<i :class="'dx-icon-' + tab.icon" style="font-size: 20px; margin-right: 10px;"></i>
							<div style="flex-grow: 1;">
								<template v-if="masterDetailTabEditing === tab.id">
									<DxTextBox v-model="tab.label" label="Tab Title" style="margin-bottom: 5px;" />
									<DxTextBox v-model="tab.icon" label="Icon name" />
									<DxSelectBox v-model="tab.relationship" label="Relationship" :data-source="masterDetailTabRelationshipSource" value-expr="keyspec" display-expr="label" />
									<DxButton text="Customize" @click="advancedMasterDetailTabEdit(tab)" type="default" style="margin-top: 10px;" width="100%" />
								</template>
								<template v-else>
									<div style="font-weight: bold;">{{ tab.label }}</div>
									<div style="color: var(--dx-color-text-muted); font-size: 0.9em;">Type: {{ tab.type }}</div>
									<div style="color: var(--dx-color-text-muted); font-size: 0.9em;">Relationship: {{ tab.relationship }}</div>
								</template>
							</div>
							<div>
								<i :class="masterDetailTabEditing === tab.id ? 'dx-icon-undo' : 'dx-icon-edit'" 
									style="font-size: 16px; color: var(--dx-color-info); margin-right: 8px; cursor: pointer;"
									@click="toggleMasterDetailTabEditing(tab)"></i>
								<i class="dx-icon-trash" style="font-size: 16px; color: var(--dx-color-danger); cursor: pointer;"
									@click="deleteMasterDetailTab(tab)"></i>
							</div>
						</div>
					</div>
				</div>
				<DxDropDownButton text="Add Master Detail Tab" display-expr="text" key-expr="id" @item-click="addMasterDetailTab($event.itemData)" style="width:100%;" :items="masterDetailTabTypes">
					<template #iconitem="{ data }">
						<div style="display:flex;flex-direction:row;align-items:center;">
							<img src="../assets/placeholder.jpg" style="width:144px;height:48px;flex-shrink:0" class="placeholder">
							<div style="flex-grow:1;margin-left:10px;">
								<div style="font-weight:bold;font-size:1.2em;">{{ data.text }}</div>
								<div style="font-size:0.9em;">{{ data.description }}</div>
							</div>
						</div>
					</template>
				</DxDropDownButton>
			</DxSimpleItem>
		</DxGroupitem>
	</DxGroupItem>

	<DxGroupItem v-if="isGridType" :css-class="settingsData.useGrouping === true ? 'ux-settings-fieldset active' : 'ux-settings-fieldset'">
		<DxSimpleItem data-field="useGrouping" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'hierarchy;Allow data grouping' }" />
		<DxSimpleItem :visible="settingsData.useGrouping !== true" :css-class="'disable-form-paddings'">
			<div style="display:flex;align-items:center;gap:10px;">
				<img src="../assets/placeholder.jpg" style="width:144px;height:48px;flex-shrink:0" class="placeholder">
				<div style="font-style: italic; color: var(--dx-color-text-muted);">Data grouping allows you to group data by a column, gathering all rows with that same value quickly.</div>
			</div>
		</DxSimpleItem>
		<DxSimpleItem :visible="settingsData.useGrouping === true" css-class="disable-form-paddings">
			<div style="font-style: italic; color: var(--dx-color-text-muted);">Data grouping can be accessed by right clicking a column header, or dragging it into the empty space above the column headers.</div>
		</DxSimpleItem>
		<DxGroupItem :visible="settingsData.useGrouping === true">	
			<DxSimpleItem data-field="noGroupingChanges" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'lock;Stop users changing grouping' }" />
		</DxGroupItem>
	</DxGroupItem>

	<DxGroupItem v-if="isGridType" :css-class="settingsData.useAggregates === true ? 'ux-settings-fieldset active' : 'ux-settings-fieldset'">
		<DxSimpleItem data-field="useAggregates" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'datafield;Calculate data aggregates / totals' }" />
		<DxSimpleItem :visible="settingsData.useAggregates !== true" css-class="disable-form-paddings">
			<div style="display:flex;align-items:center;gap:10px;">
				<img src="../assets/placeholder.jpg" style="width:144px;height:48px;flex-shrink:0" class="placeholder">
				<div style="font-style: italic; color: var(--dx-color-text-muted);">Aggregates can calculate totals, counts or averages for any column in your data. When data is grouped, this can also be shown per group.</div>
			</div>
		</DxSimpleItem>
		<DxGroupItem :visible="settingsData.useAggregates === true">
			<DxSimpleItem data-field="aggregates" editor-type="dxSelectBox" :editor-options="aggregatesConfig" />
			<DxSimpleItem data-field="showGroupAggregates" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'rowfield;Show aggregates in grouped rows' }" />
		</DxGroupItem>
	</DxGroupItem>


	<DxGroupItem v-if="props.type == 'calendar'">
		<DxSimpleItem data-field="bindTitle" editor-type="dxSelectBox" :editor-options="fieldConfig" :label="{ text: 'Title from...'}" />
		<DxSimpleItem data-field="bindFromDate" editor-type="dxSelectBox" :editor-options="fieldConfig" :label="{ text: 'Date of event...'}" />
		<DxSimpleItem data-field="startingDate" editor-type="dxSelectBox" :editor-options="calendarStartingDates" :label="{ text: 'Show starting calendar page for...'}" />
	</DxGroupItem>

	<DxGroupItem v-if="props.type == 'list'">
		<DxSimpleItem data-field="bindTitle" editor-type="dxSelectBox" :editor-options="fieldConfig" :label="{ text: 'Title from...'}" />
		<DxSimpleItem data-field="bindSubtitle" editor-type="dxSelectBox" :editor-options="fieldConfig" :label="{ text: 'Subtitle from...'}" />
		<DxSimpleItem data-field="bindBadge" editor-type="dxSelectBox" :editor-options="fieldConfig" :label="{ text: 'Badge from...'}" />
	</DxGroupItem>
	
	<!--
	<DxGroupItem>
		<DxSimpleItem data-field="showSearch" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'search;Show search filter at top' }" />
		<DxSimpleItem data-field="allowReload" editor-type="dxSwitch" :label="{ template: 'iconLabel', location: 'left', text: 'refresh;Allow reload by pulling down' }" />
	</DxGroupItem>
	<DxSimpleItem data-field="filter">
		<div class="dx-card-title">Filter data</div>
		<div class="dx-card" style="padding:10px;border-left:5px solid var(--dx-color-icon)">
			<DxFilterBuilder :fields="filterBuilderFields" v-model:value="filterBuilderValue" v-if="settingsData.source" />
		</div>
	</DxSimpleItem>
	-->
	<template #iconLabel="{ data: label }">
		<i :class="'checkbox-label-icon dx-icon-' + label.text.split(';')[0]"></i>
		<span>
			{{ label.text.split(';')[1] }}
		</span>
	</template>
</DxForm>
</template>

<script setup>
/* eslint-disable */
import { DxForm, DxSimpleItem, DxGroupItem } from "devextreme-vue/form";
import { DxSelectBox } from 'devextreme-vue/select-box';		// eslint-disable-line no-unused-vars
import { DxSwitch } from "devextreme-vue/switch";				// eslint-disable-line no-unused-vars
import DxButton from 'devextreme-vue/button';
import { DxDropDownButton } from 'devextreme-vue/drop-down-button';
import { defineProps, defineEmits, ref, watch, computed, nextTick, inject } from 'vue';
import DataSource from 'devextreme/data/data_source';
import DxFilterBuilder from 'devextreme-vue/filter-builder';
import { confirm } from 'devextreme/ui/dialog';
import { DxTextBox } from 'devextreme-vue/text-box';
import DropzoneFile from '../components/dropzone-file';
import { SchemaCache } from '../schemas';
import CoderPrompter from '../components/coder-prompter.vue';

const props = defineProps({
	type: String,
	settings: Object,
	context: Object,				// NB: Context is the parent page object -- but make sure we do NOT do any changes to it.
});
const emit = defineEmits(['settingsChanged', 'triggerSubeditor']);

const settingsData = ref({});					// All settings for the cell being edited - passed to the ux-* component by ux-settings-editor.
const isGridType = computed(() => {
	return props.type == 'datagrid' || props.type == 'mdt-subgrid';
});
const isSubeditor = computed(() => {
	return props.type && props.type.startsWith('mdt-');
});
const showSourceSelector = computed(() => {
	return props.type && props.type != 'imageview' && !isSubeditor.value;
});

// Our props settings are provided to us by parent ux-settings-editor. We watch for changes, updating our reference, and emit changes back to the parent.
// The parent always uses a clone of the data passed in to it, so this should be safe.
const isLoadingValues = ref(false);
watch(props, () => {
	isLoadingValues.value = true;
	// NB: I don't think we need to clone here, but hopefully we are allowed to directly use this. If anything weird starts happening, use a JSON.parse(JSON.stringify(props.settings)) clone.
	settingsData.value = props.settings ? props.settings : {};
	nextTick(() => {
		isLoadingValues.value = false;
	});
}, { immediate: true });
const handleFieldDataChanged = () => {
	if (isLoadingValues.value)
		return;
	emit('settingsChanged', settingsData.value);
}

// Common settings for all types of cells.
const sourceConfig = {
	dataSource: new DataSource({
		loadMode: 'raw',
		key: 'keyspec',
		load: async () => {
			await SchemaCache.waitForData();
			return SchemaCache.getAllSchemasExceptRelations();
		},
		// group: 'folder',
	}),
	// grouped: true,
	searchEnabled: true,
	displayExpr: 'plural', valueExpr: 'keyspec',
	buttons: [
		{ location: 'after', name: 'Data model', options: { text: 'Select from data model', icon: 'sun' } },
	],
};
const fieldConfig = {
	dataSource: new DataSource({
		loadMode: 'raw',
		key: 'keyspec',
		load: async () => {
			await SchemaCache.waitForData();
			return SchemaCache.getAllFields();
		},
	}),
	searchEnabled: true,
	displayExpr: 'label', valueExpr: 'keyspec',
};

// Settings for dataGrid.
const filterBuilderValue = ref([]);				// TODO: ?
const filterBuilderFields = ref([]);			// TODO: ?
const masterDetailTabEditing = ref(null);		// Index of the master detail tab we are editing, or null.
const masterDetailModes = {
	displayExpr: 'text', valueExpr: 'id', items: [ { id: 'tab', text: 'Tabbed' }, { id: 'page', text: 'Custom page' } ]
};
const masterDetailTabTypes = [
	{ id: 'itemview', text: 'Item View', description: 'Display the full view of a single item - usually what was expanded.', template: 'iconitem' },
	{ id: 'list', text: 'List View', description: 'Display a simple list of items, showing one to three simple pieces of information.', template: 'iconitem' },
	{ id: 'datagrid', text: 'Data Grid', description: 'Display a grid of items, showing lots of information.', template: 'iconitem' },
	{ id: 'drive', text: 'Drive', description: 'Display a drive containing files and folders.', template: 'iconitem' },
	{ id: 'comments', text: 'Comments', description: 'Display a list of comments or discussions.', template: 'iconitem' },
	{ id: 'editor', text: 'Editor', description: 'Display an editor for creating and editing content.', template: 'iconitem' }
];
const editingModes = {
	displayExpr: 'text', valueExpr: 'id', items: [ { id: 'none', text: "Disallow all editing (adding, deleting)" }, { id: 'row', text: "Edit directly in table" }, { id: 'form', text: "Edit in form" }, { id: 'popup', text: "Edit in popped up form" } ]
}
const aggregatesConfig = {
	displayExpr: 'text', valueExpr: 'id', items: [ { id: 'count', text: "Count" }, { id: 'sum', text: "Sum" }, { id: 'avg', text: "Average" }, { id: 'min', text: "Minimum" }, { id: 'max', text: "Maximum" } ]
}
const simpleClickModes = {
	displayExpr: 'text', valueExpr: 'id', items: [ { id: 'none', text: "No effect on clicking" }, { id: "page", text: "Goto page on click" } ]
}
// TODO: We need to make sure we clear all groupIndex options in the preview datagrid and any possible settings when we turn off useGrouping!

// Settings for calendar.
const calendarStartingDates = {
	displayExpr: 'text', valueExpr: 'id', items: [ 
		{ id: 'now', text: "Current date" }, 
		{ id: 'recent_now', text: "Most recent date up to today" }, 
		{ id: 'recent', text: "Most recent date including future dates" }, 
		{ id: 'oldest', text: "Earliest date in dataset" } 
	]
};

// TODO: Sort these out!
const showSearchConfig = {
	switchedOnText: 'On',
	switchedOffText: 'Off',
};
/*watch(filterBuilderValue, () => {
	settingsData.value.filter = JSON.parse(JSON.stringify(filterBuilderValue.value));
});*/

// TODO: Deal with what happens when the source changes - do we reset our things that depend on fields/sources, like all the binding or filters? Do they stay in our settingsData by accident!?
let lastSource = settingsData.value.source;
watch(settingsData, async () => {
	if (lastSource != settingsData.value.source) {
		lastSource = settingsData.value.source;
		fieldConfig.dataSource.filter([ 'schema_type', '=', settingsData.value.source ]);
		fieldConfig.dataSource.load();
		// settingsData.value.bindTitle = ''; settingsData.value.bindSubtitle = ''; settingsData.value.bindBadge = '';		// <-- we obviously can't just nuke this!
		// Set default bindTitle if possible.
		/*
		if (props.type == 'list' && !settingsData.value.bindTitle && settingsData.value.source) {
			let guessTitle = Fields.find(f => f.schema == settingsData.value.source && f.defaultLabel);
			if (guessTitle && guessTitle.field)
				settingsData.value.bindTitle = guessTitle.field;
		}
		*/
		// Setup column fields for FilterBuilder if needed.
		// TODO: ? Needed?
		await SchemaCache.waitForData();
		var columns = settingsData.value.source ? (SchemaCache.getSchemaByType(settingsData.value.source)?.fields ?? []) : [];
		filterBuilderFields.value = columns.map(f => { return {
			caption: f.label,
			dataField: f.field,
			dataType: f.getDxDataType(),
			// format: ???
		}});
	}
}, { deep: true });

const addMasterDetailTab = (itemData) => {
	console.log("Add master detail tab", itemData);
	if (!('masterDetailTabs' in settingsData.value))
		settingsData.value.masterDetailTabs = [];
	let largestId = settingsData.value.masterDetailTabs.length > 0 ? settingsData.value.masterDetailTabs.reduce((max, tab) => Math.max(max, tab.id), 0) : 0;
	let iconPresets = {
		'itemview': 'card',
		'list': 'fields',
		'datagrid': 'tableproperties',
		'drive': 'folder',
		'comments': 'comment',
		'editor': 'edit',
	};
	settingsData.value.masterDetailTabs.push({ id: largestId + 1, type: itemData.id, label: itemData.text, icon: iconPresets[itemData.id] });
}

const toggleMasterDetailTabEditing = (tab) => {
	if (masterDetailTabEditing.value === tab.id) {
		masterDetailTabEditing.value = null;
	} else {
		masterDetailTabEditing.value = tab.id;
	}
};
// When the user clicks on the advanced 'customize' button for a master detail tab, we ask our parent to start a subeditor - swapping out our current ux-settings-editor-form with
// one that is specialized for editing just this tab section of the settingsData.
const advancedMasterDetailTabEdit = (tab) => {
	console.log("Advanced master detail tab edit", tab);
	if (tab && tab.id)
		emit('triggerSubeditor', { type: 'mdt-subgrid', label: tab.label, subset: tab });
}

const deleteMasterDetailTab = (tab) => {
	const sanitizedLabel = tab.label.replace(/[<>]/g, '').replace(/"/g, '&quot;');
	confirm(`Are you sure you want to delete the "${sanitizedLabel}" tab?`, "Confirm deletion").then(result => {
		if (result)
			settingsData.value.masterDetailTabs = settingsData.value.masterDetailTabs.filter(t => t.id !== tab.id);
	});
};

// Data source for the master detail tab's datagrid relationship configuration dropdown. It should show all relationship fields for the current source.
const masterDetailTabRelationshipSource = new DataSource({
	loadMode: 'raw',
	key: 'keyspec',
	load: async () => {
		await SchemaCache.waitForData();
		return SchemaCache.getSchemaByType(settingsData.value.source)?.fields.filter(f => f.fieldtype == 'relationship');
	},
});

const editorRootStyles = computed(() => {
	let calculatedWidth = props.useRecommendedWidth && props.recommendedWidth ? `${props.recommendedWidth + 500}px` : undefined;
	return {
		display: 'flex',
		height: 'calc(100% - 50px)',
		width: calculatedWidth,
	}
});

// HTML editor settings.
const htmlModes = {
	displayExpr: 'text', valueExpr: 'id', items: [ { id: 'simple', text: "Simple Richtext Editor" }, { id: 'full', text: "AI-assisted HTML" } ]
}

</script>

<style lang="scss">
.checkbox-label-icon {
	font-size: 24px;
	vertical-align: middle;
	margin: 0 6px 0 4px;
}
.ux-settings-fieldset {
	margin: 16px 0;
	padding: 16px;
	border: 1px solid var(--dx-color-border);
	border-radius: 8px;
	background-color: var(--dx-background-color);
	transition: all 0.6s ease;
}
.ux-settings-fieldset.active {
	border-left: 4px solid var(--dx-color-primary);
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
	transition: all 0.6s ease;
}
.ux-settings-fieldset.active.always-active {
	border-left-color: var(--dx-color-success);
}
.ux-settings-fieldset:hover {
	background-color: var(--dx-background-color-hover, rgba(0, 0, 0, 0.02));
}
.ux-settings-fieldset .form-hint {
	font-style: italic;
	font-size: 0.9em;
	color: #555;
}
</style>